export interface ProgressProps {
  value: number; // 0 a 100
  currentStep?: number;
  totalSteps?: number;
  label?: string;
  showPercentage?: boolean;
  className?: string;
}

export function Progress({
  value,
  currentStep,
  totalSteps,
  label = 'Progresso do diagnóstico',
  showPercentage = false,
  className = '',
}: ProgressProps) {
  const clampedValue = Math.max(0, Math.min(100, Math.round(value)));

  return (
    <div className={`w-full ${className}`}>
      {(currentStep !== undefined || showPercentage) && (
        <div className="mb-2 flex items-center justify-between text-xs font-medium text-brand-offWhite/80">
          <span>
            {currentStep !== undefined && totalSteps !== undefined ? (
              <span className="font-semibold text-white">
                Pergunta <span className="text-brand-orange">{currentStep}</span> de {totalSteps}
              </span>
            ) : (
              label
            )}
          </span>
          {showPercentage && <span className="text-brand-orange font-bold">{clampedValue}%</span>}
        </div>
      )}

      <div
        role="progressbar"
        aria-valuenow={clampedValue}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
        className="h-2.5 w-full overflow-hidden rounded-full bg-white/10"
      >
        <div
          className="h-full rounded-full bg-gradient-to-r from-brand-orange to-brand-orangeSecondary transition-all duration-300 ease-out motion-reduce:transition-none"
          style={{ width: `${clampedValue}%` }}
        />
      </div>
    </div>
  );
}
